var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var ensureExistence = (scopeName, key) => {
	var scope = __webpack_require__.S[scopeName];
	if(!scope || !__webpack_require__.o(scope, key)) throw new Error("Shared module " + key + " doesn't exist in shared scope " + scopeName);
	return scope;
};
var findVersion = (scope, key) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key) => {
	var versions = scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getSingleton = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	return get(scope[key][version]);
};
var getSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var getStrictSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) throw new Error(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var findValidVersion = (scope, key, requiredVersion) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ") of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var getValidVersion = (scope, scopeName, key, requiredVersion) => {
	var entry = findValidVersion(scope, key, requiredVersion);
	if(entry) return get(entry);
	throw new Error(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var warn = (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var warnInvalidVersion = (scope, scopeName, key, requiredVersion) => {
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var init = (fn) => (function(scopeName, a, b, c) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then) return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], a, b, c));
	return fn(scopeName, __webpack_require__.S[scopeName], a, b, c);
});

var load = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return get(findVersion(scope, key));
});
var loadFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	return scope && __webpack_require__.o(scope, key) ? get(findVersion(scope, key)) : fallback();
});
var loadVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getValidVersion(scope, scopeName, key, version);
});
var loadStrictSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var loadVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingletonFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	var entry = scope && __webpack_require__.o(scope, key) && findValidVersion(scope, key, version);
	return entry ? get(entry) : fallback();
});
var loadStrictSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var installedModules = {};
var moduleToHandlerMapping = {
	8416: () => (loadSingletonVersionCheckFallback("default", "react", [1,18,2,0], () => (__webpack_require__.e(7294).then(() => (() => (__webpack_require__(7294))))))),
	1051: () => (loadSingletonVersionCheckFallback("default", "react-dom", [1,18,2,0], () => (__webpack_require__.e(3935).then(() => (() => (__webpack_require__(3935))))))),
	8179: () => (loadStrictVersionCheckFallback("default", "react-router", [1,5,3,3], () => (Promise.all([__webpack_require__.e(71), __webpack_require__.e(6550)]).then(() => (() => (__webpack_require__(6550))))))),
	4180: () => (loadSingletonVersionCheckFallback("default", "oasis-os-utils", [1,1,15,1], () => (Promise.all([__webpack_require__.e(3676), __webpack_require__.e(5861)]).then(() => (() => (__webpack_require__(6746))))))),
	7821: () => (loadStrictVersionCheckFallback("default", "@ionic/react", [4,6,2,2], () => (Promise.all([__webpack_require__.e(7210), __webpack_require__.e(8832), __webpack_require__.e(1051), __webpack_require__.e(9731)]).then(() => (() => (__webpack_require__(8832))))))),
	5449: () => (loadStrictVersionCheckFallback("default", "react-router-dom", [1,5,3,3], () => (Promise.all([__webpack_require__.e(71), __webpack_require__.e(8179), __webpack_require__.e(9815)]).then(() => (() => (__webpack_require__(3727))))))),
	5819: () => (loadStrictVersionCheckFallback("default", "oasis-os-react", [1,1,8,15], () => (__webpack_require__.e(8719).then(() => (() => (__webpack_require__(8719))))))),
	48: () => (loadStrictVersionCheckFallback("default", "@ionic/core", [4,6,2,2], () => (Promise.all([__webpack_require__.e(9905), __webpack_require__.e(3076)]).then(() => (() => (__webpack_require__(9905))))))),
	744: () => (loadSingletonVersionCheckFallback("default", "oasis-feature-api", [2,0,54,10], () => (Promise.all([__webpack_require__.e(1869), __webpack_require__.e(7209), __webpack_require__.e(3617)]).then(() => (() => (__webpack_require__(1869))))))),
	2929: () => (loadStrictVersionCheckFallback("default", "oasis-os-contentful", [1,2,4,4], () => (Promise.all([__webpack_require__.e(7910), __webpack_require__.e(9788), __webpack_require__.e(9782)]).then(() => (() => (__webpack_require__(9788))))))),
	3531: () => (loadStrictVersionCheckFallback("default", "@ionic/react-router", [4,6,2,2], () => (Promise.all([__webpack_require__.e(71), __webpack_require__.e(6282), __webpack_require__.e(9907)]).then(() => (() => (__webpack_require__(6282))))))),
	3787: () => (loadSingletonVersionCheckFallback("default", "oasis-auth", [2,0,20,4], () => (Promise.all([__webpack_require__.e(4746), __webpack_require__.e(1763), __webpack_require__.e(2480)]).then(() => (() => (__webpack_require__(1763))))))),
	5285: () => (loadSingletonVersionCheckFallback("default", "oasis-os-common", [1,1,56,13], () => (Promise.all([__webpack_require__.e(6778), __webpack_require__.e(1051), __webpack_require__.e(8528), __webpack_require__.e(1438), __webpack_require__.e(8793)]).then(() => (() => (__webpack_require__(6778))))))),
	6264: () => (loadSingletonVersionCheckFallback("default", "oasis-os-theming", [1,1,6,0], () => (__webpack_require__.e(707).then(() => (() => (__webpack_require__(2291))))))),
	9907: () => (loadStrictVersionCheckFallback("default", "@ionic/react", [4,6,2,2], () => (Promise.all([__webpack_require__.e(7210), __webpack_require__.e(7651), __webpack_require__.e(1051), __webpack_require__.e(842)]).then(() => (() => (__webpack_require__(7651))))))),
	8528: () => (loadSingletonVersionCheckFallback("default", "oasis-os-utils", [1,1,15,1], () => (Promise.all([__webpack_require__.e(1616), __webpack_require__.e(8416)]).then(() => (() => (__webpack_require__(1616))))))),
	7209: () => (loadSingletonVersionCheckFallback("default", "oasis-os-utils", [1,1,15,1], () => (Promise.all([__webpack_require__.e(3676), __webpack_require__.e(3477), __webpack_require__.e(8416)]).then(() => (() => (__webpack_require__(7419))))))),
	3617: () => (loadStrictVersionCheckFallback("default", "oasis-os-react", [1,1,8,15], () => (Promise.all([__webpack_require__.e(7887), __webpack_require__.e(8416)]).then(() => (() => (__webpack_require__(7887))))))),
	1438: () => (loadStrictVersionCheckFallback("default", "oasis-os-react", [1,1,8,15], () => (Promise.all([__webpack_require__.e(4607), __webpack_require__.e(8416)]).then(() => (() => (__webpack_require__(4607))))))),
	258: () => (loadSingletonVersionCheckFallback("default", "oasis-auth", [2,0,20,4], () => (Promise.all([__webpack_require__.e(4746), __webpack_require__.e(5312), __webpack_require__.e(5629)]).then(() => (() => (__webpack_require__(5312))))))),
	4734: () => (loadSingletonVersionCheckFallback("default", "oasis-os-theming", [1,1,6,0], () => (__webpack_require__.e(4893).then(() => (() => (__webpack_require__(2670))))))),
	5628: () => (loadStrictVersionCheckFallback("default", "oasis-os-contentful", [1,2,4,4], () => (Promise.all([__webpack_require__.e(7910), __webpack_require__.e(8924), __webpack_require__.e(9782)]).then(() => (() => (__webpack_require__(8924))))))),
	9340: () => (loadSingletonVersionCheckFallback("default", "oasis-feature-api", [2,0,54,10], () => (__webpack_require__.e(4457).then(() => (() => (__webpack_require__(4457))))))),
	9782: () => (loadStrictVersionCheckFallback("default", "contentful", [1,9,1,33], () => (Promise.all([__webpack_require__.e(6627), __webpack_require__.e(4654)]).then(() => (() => (__webpack_require__(6627)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"1051": [
		1051
	],
	"1438": [
		1438
	],
	"3617": [
		3617
	],
	"4174": [
		48,
		744,
		2929,
		3531,
		3787,
		5285,
		6264
	],
	"4180": [
		4180
	],
	"5449": [
		5449
	],
	"5819": [
		5819
	],
	"7209": [
		7209
	],
	"7821": [
		7821
	],
	"8179": [
		8179
	],
	"8416": [
		8416
	],
	"8528": [
		8528
	],
	"8793": [
		258,
		4734,
		5628,
		9340
	],
	"9782": [
		9782
	],
	"9907": [
		9907
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
		});
	}
}